"use client";

import { useQueryClient } from "@tanstack/react-query";

import type { MethodVariables } from "../../../../../request/hooks/openApi/useOpenApiMutation";
import { useOpenApiMutation } from "../../../../../request/hooks/openApi/useOpenApiMutation";
import { keyCommunitiesStripeConnectStatus } from "./keyCommunitiesStripeConnectStatus";

export const useRequestMutationsCommunitiesStripeConnect = ({
  id,
}: {
  id: number;
}) => {
  const queryClient = useQueryClient();

  const mutation = useOpenApiMutation<
    "POST",
    "/me/communities/{community_id}/stripe/connect"
  >({
    urlBackendPath: "/me/communities/{community_id}/stripe/connect",
    method: "POST",
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: keyCommunitiesStripeConnectStatus({ id }),
      });
    },
  });

  return {
    mutationConnect: {
      ...mutation,
      mutateAsync: (
        variables?: MethodVariables<
          "/me/communities/{community_id}/stripe/connect",
          "POST"
        >,
      ) =>
        mutation.mutateAsync({
          ...variables,
          params: { path: { community_id: id } },
        }),
      mutate: (
        variables?: MethodVariables<
          "/me/communities/{community_id}/stripe/connect",
          "POST"
        >,
        options?: any,
      ) =>
        mutation.mutate(
          {
            ...variables,
            params: { path: { community_id: id } },
          },
          options,
        ),
    },
  };
};
